export default "__VITE_ASSET__CZa2d15L__"